import { redirectToLogin } from 'utils/login';

export const handle403 = () => {
  redirectToLogin();
};
